/**
 * 
 * 
 * 
 * @modify date 2020-09-16 11:10
 */

import Base from '@/libs/requests/Base';
import Form from '@/libs/requests/Form';
import Analytics from "@/libs/analytics/Analytics";

import { fields } from './AppealRepository';
const routePrefix = 'appeals' 

export default class Appeal extends Base {

    constructor() {
        super(fields);

        this.form = new Form(fields);

        this.analytics = new Analytics();

        this.selected = null;

        this.appeals = null;

        this.saved = false;

        this.deleted = false;

    }

    getAll(params = {}) {
        let url = `${routePrefix}?`;

        url += this.querifyObject(params)

        this.form.submit('get', url).then(response => {
            
            this.appeals = response;

             this.analytics.logQuery(params.search, params)
 
        });
    }
    getAllTC(params = {}) {
        let url = `${routePrefix}?`;

        url += this.querifyObject(params)

        this.form.submit('get', url).then(response => {

            this.appeals = response;

             this.analytics.logQuery(params.search, params)
 
        });
    }
    getAllCB(params = {}) {
        let url = `${routePrefix}?`;

        url += this.querifyObject(params)

        this.form.submit('get', url).then(response => {

            this.appeals = response;

             this.analytics.logQuery(params.search, params)
 
        });
    }

    get(id, prefill = false) {
        let url = `/${routePrefix}/${id}`;

        this.form.submit('get', url).then(response => {

            this.selected = response;

           

        });
    }

    create() {
        let data = this.columns
        this.saved = false;

        this.form.submit('post', `/${routePrefix}`, data).then(response => {

            this.saved = true;

            flash({message: 'Etkinlik Eklendi', alert: 'success'})

        });
    }

    update(id, prefill = false) {
        let data = this.columns
        this.saved = false;

        this.form.submit('put', `/${routePrefix}/${id}`, data).then(response => {

            this.saved = true;

            flash({message: 'Etkinlik Güncellendi', alert: 'success'})

           
        });
    }

    delete(id) {
        this.deleted = false;
        let url = `/${routePrefix}/${id}`;

        this.form.submit('delete', url).then(response => {

            this.deleted = true;

            flash({message: 'Etkinlik Silindi', alert: 'success'})

        });
    }

    deleteAll() {
        this.deleted = false;

        this.form.submit('delete', `/${routePrefix}`, data).then(response => {

            this.deleted = true;

            flash({message: 'All Appeals Deleted', alert: 'success'})

        });
    }

    findByTitle(title) {
        let url = `/${routePrefix}?title=${title}`

        this.form.submit('get', url).then(response => {

            this.appeals = response;

        });
    }

    reset() {
        this.columns.institution= null,
        this.columns.hbvunits= null,
        this.columns.supportInst= null,
        this.columns.otherInst= null,
      
        this.columns.eventType= null,

        this.columns.eventName= null,
        this.columns.startDate= null,
        this.columns.endDate= null,
        this.columns.startTime= null,
        this.columns.endTime= null,
        this.columns.room= null,
      
        this.columns.description= null,
        this.columns.makamOnay= null,
        this.columns.smsEmail= null,
      

      
      //information
      this.columns.national= null,
      this.columns.repeat= null,
      this.columns.address= null,
      this.columns.selectedLanguages= [],

      this.columns.eventTask= null,
      this.columns.inHouse= null,
      this.columns.author= null,
      
      this.columns.individual= null,
      this.columns.place= null,
      this.columns.target= null,
      
       
      this.columns.fon= null,
      this.columns.moneyType= null,

      this.columns.theme= null,
      this.columns.juri= null,
      this.columns.juriList= null,

      this.columns.relations= null,
      this.columns.socials= null,

      this.columns.insideOtherEvent= null,
      this.columns.relatedEvent= null,
      this.columns.otherEventTask= null,

      //sayfa3
      this.columns.science= null,
      this.columns.bilimselAciklama= null,
      this.columns.prize= null,
      this.columns.studentProject= false,
      this.columns.videoLink= null,

       
        this.columns.published = false
    }

    prefill(data) {
        this.columns.institution = data.null
        this.columns.hbvunits = data.null
        this.columns.supportInst = data.null
        this.columns.otherInst = data.null
        this.columns.otherSupportInst = data.null
        this.columns.eventType = data.null
        this.columns.otherEventType = data.null
        this.columns.eventName = data.null
    }
}